import { render, staticRenderFns } from "./breeder-bio-details-container.vue?vue&type=template&id=934677d6&scoped=true&lang=pug"
import script from "./breeder-bio-details-container.js?vue&type=script&lang=js&external"
export * from "./breeder-bio-details-container.js?vue&type=script&lang=js&external"
import style0 from "./breeder-bio-details-container.vue?vue&type=style&index=0&id=934677d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934677d6",
  null
  
)

export default component.exports